module.exports = __webpack_public_path__ + "img/ss-1.8643946c.png";